// @ts-nocheck
/* eslint-disable */
export const outlineAddIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12 8.993H4a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h8c.273 0 .5.227.5.5 0 .274-.227.5-.5.5"/><path fill="currentColor" d="M8 12.993a.504.504 0 0 1-.5-.5v-8c0-.273.227-.5.5-.5s.5.227.5.5v8c0 .274-.227.5-.5.5"/></svg>`,
    name: 'outline-add' as const
};